module.exports = __webpack_public_path__ + "img/e4_img5.8e0532b.jpg";